import { useContext } from "react"
import { useNavigate } from "react-router-dom"

import { WidgetTag, provideComponent } from "scrivito"
import { DataFormContext } from "scrivito/Widgets/DataFormContainerWidget/DataFormContainerWidgetComponent"
import { useEvent } from "shared/lib/useEvent"
import { Button, ButtonVariant } from "shared/ui/buttons/Button"

import { alignmentClassName } from "../utils/alignmentClassName"
import { DataFormSubmitButtonWidget } from "./DataFormSubmitButtonWidgetClass"

provideComponent(DataFormSubmitButtonWidget, ({ widget }) => {
  const { isSubmitting } = useContext(DataFormContext)
  const navigate = useNavigate()

  const handleCancel = useEvent(() => {
    navigate(widget.get("cancelAndBackToUrl"))
  })

  return (
    <WidgetTag
      className={`d-flex align-items-center ${alignmentClassName(
        widget.get("alignment")
      )}`}
    >
      {widget.get("hasCancel") && (
        <Button variant={ButtonVariant.TERTIARY} onClick={handleCancel}>
          {widget.get("cancelTitle")}
        </Button>
      )}
      <Button
        type="submit"
        variant={ButtonVariant.PRIMARY}
        isLoading={isSubmitting}
      >
        {widget.get("submitTitle")}
      </Button>
    </WidgetTag>
  )
})
